import { createContext, useContext } from 'react';
import { ChatStrings, getChatStrings } from './i18n';

/**
 * The current interface strings, for components created outside the render tree's props flow
 * (the sign-in card is created once as a message element, so it reads the strings from here to
 * follow a language switch).
 */
export const ChatStringsContext = createContext<ChatStrings>(getChatStrings('en'));

export const useChatStrings = (): ChatStrings => useContext(ChatStringsContext);
